import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export interface ThemeUpdatedEvent {
	previousTheme: string;
	theme: string;
}

@Injectable({
	providedIn: 'root',
})
export class ThemeUpdateService {
	private readonly _themeUpdated = new Subject<ThemeUpdatedEvent>();

	public themeUpdated$ = (): Observable<ThemeUpdatedEvent> => {
		return this._themeUpdated.asObservable();
	};

	public announceThemeUpdated = (
		previousTheme: string,
		theme: string,
	): void => {
		this._themeUpdated.next({ previousTheme, theme });
	};
}
